// extracted by mini-css-extract-plugin
export var lg = "_ka-7";
export var md = "_ka-6";
export var placeholderContainer = "_ka-1";
export var placeholderIcon = "_ka-2";
export var productImage = "_ka-0";
export var sm = "_ka-5";
export var xl = "_ka-8";
export var xs = "_ka-4";
export var xxs = "_ka-3";